import EventEmitter from 'eventemitter3';
import { wsSubject } from '~/common/js/rx-websocket-user';
import { useP2pStore } from '~/store/p2p';

// 奇怪 感觉web-worker卡卡的

interface UserWebSocketRespoense {
  type: string,
  payload: {
    uid?: number,
    subscribe: string,
    data: P2PUpdateData,
  }
}

interface P2PUpdateData {
  // 用户委托单状态更新
  advertise?: {
    adId: number,
    state: number,
  },
  order?: {
    orderId: number
  },
  processingOrderCount?: number,
  type?: number,
}

// nuxtApp, inject
export default defineNuxtPlugin(() => {
  const ee = new EventEmitter();
  const p2pStore = useP2pStore();
  // let decoder
  
  const handleWsMessage = (res: UserWebSocketRespoense) => {
    
    const { type, payload } = res;
    if (!wsSubject.ws) {
      console.log("ws: 任意路由都启动connect");
      wsSubject.connect();
    }
    if(type !== 'p2p'){
      // TODO 可处理其他订阅，暂时没有
      return;
    }
    // 
    if(type === 'p2p' && payload.data){
      p2pStore.UPDATE_BY_SUBSCRIBE(payload);
    }
  };

  wsSubject.on('postMessage', handleWsMessage);

  // ws.postMessage({
  //   type: WORKER_MSG_TOPIC.get('INIT'),
  //   payload: {
  //     env,
  //     query,
  //     params,
  //   },
  // })
  // nuxtApp.provide('socketWorker', {ws,ee});

  return {
    provide: {
      socketWorker: {wsSubject, ee},
    },
  };
});
